import { render, staticRenderFns } from "./Reviewmanagement.vue?vue&type=template&id=5f20fc6f&"
import script from "./Reviewmanagement.vue?vue&type=script&lang=js&"
export * from "./Reviewmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports